<template>
  <layout-wrapper :background-name=" isMinimized ? 'bg-light-grey' : 'bg-transparent'" class="bg-light-grey">
    <template #header>
      <div class="transition-all duration-300">
        <div v-if="isMinimized" class="bg-white">
          <home-search class="!p-3"/>
        </div>
        <div v-if="!isMinimized" :class="{'!p-3 bg-white': !isNewBannerExists, 'mb-3': tabs?.length < 2}"
             class="flex justify-center items-center gap-4 pt-4 px-4">
          <nuxt-link :to="$routerUrl('/categories')" class="flex-center">
            <van-icon :name="$publicPath('/images/header/category.svg')" class="min-w-[24px]" size="24"/>
          </nuxt-link>
          <home-search class="!p-0"/>
          <nuxt-link :to="$routerUrl('/notifications')" class="flex-center">
            <van-icon :name="$publicPath('/images/header/notification.svg')" class="min-w-[24px]" size="24"/>
          </nuxt-link>
        </div>
      </div>
    </template>

    <van-tabs v-if="tabs.length > 1" v-model:active="tabId" class="flex-center pb-2 z-2" line-height="0" shrink>
      <van-tab v-for="(tab, index) in tabs" :key="`tab-${index}`" :name="tab.tab_id" :title="tab.title">
      </van-tab>
    </van-tabs>

    <dynamic-components :banner-v2="isNewBannerExists" :components-data="getActiveTabComponents"/>

    <full-page-loader :loading="isLoading"/>

    <!-- For showing video popup based on query params video_id -->
    <video-popup/>

  </layout-wrapper>
</template>

<script setup>
import HomeSearch from "@/components/home/Search"
import VideoPopup from "@/components/home/VideoPopup"
import {track} from "@/composables/useTrackEvent";
import {TRACKERS} from "@/constants/events";
import {useHomeStore} from "@/store/home";
import {useCustomFetch} from "@/composables/useFetch";
import {useWindowScroll} from '@vueuse/core'
import {NEW_BANNER_V2} from "@/constants";

const homeStore = useHomeStore()
const {tabId, persistentTab} = storeToRefs(homeStore)

const {
  loading: homeDataLoading,
  data: homeData
} = await useCustomFetch('?route=rest/product_admin/app_mainScreen_v2')
const tabs = computed(() => homeData.value?.tabs || [])

const tabLoading = ref(false)

// get default tab value
const defaultTabId = computed(() => tabs.value.length && tabs.value.find(item => Number(item.default_selected))?.tab_id || '')
tabId.value = persistentTab.value || defaultTabId.value

const {
  loading: tabsDataLoading,
  data: tabsComponents,
} = await useCustomFetch('?route=rest/product_admin/tabComponents', {tab_id: tabId})
const isLoading = computed(() => homeDataLoading.value || tabsDataLoading.value || false)

const getActiveTabComponents = computed(() => {
  if (!tabs.value?.length || tabLoading.value || tabsDataLoading.value) return []
  if (tabs.value.length === 1) return tabs.value[0]?.components

  const tabsData = tabs.value.find(item => item?.tab_id === tabId?.value)?.components
  return tabsData?.length ? tabsData : tabsComponents.value?.components
})

const {y: topPosition} = useWindowScroll()
const isMinimized = computed(() => topPosition.value > 40)

const isNewBannerExists = computed(() => !!getActiveTabComponents.value?.find(item => item.type === NEW_BANNER_V2) || false)

watch(tabId, (tabId) => {
  tabLoading.value = true

  const {en_name: name} = tabs.value?.find(item => item?.tab_id === tabId) || {}
  track(TRACKERS.VIEW_HOME_TAB, {name, tabId})

  // for make home tab selection persistent
  persistentTab.value = tabId

  // scroll to top
  window.scrollTo({
    top: 0,
    left: 0
  });

  nextTick(() => {
    tabLoading.value = false
  })
})
</script>

<style scoped>
</style>